import {
  Bell,
  CreditCard,
  FileText,
  Megaphone,
  RefreshCw,
  ShieldCheck,
} from "lucide-react";

/**
 * Picks the icon for a notification's `Type`.
 *
 * The backend creates unknown Type values on the fly, so this cannot be an
 * exhaustive map — anything the dashboard invents tomorrow has to land
 * somewhere sensible today. Matching on substrings means "MotorPolicyRenewal"
 * and "PolicyRenewal" both read as a renewal, and anything unrecognised falls
 * back to a plain bell rather than rendering an empty circle.
 */
const TYPE_ICONS = [
  [/renew/i, RefreshCw],
  [/claim/i, FileText],
  [/announce|maintenance|news|offer/i, Megaphone],
  [/pay|invoice|premium|refund/i, CreditCard],
  [/polic|cover|insur/i, ShieldCheck],
];

export const getNotificationIcon = (type) => {
  if (!type) return Bell;
  const match = TYPE_ICONS.find(([pattern]) => pattern.test(type));
  return match ? match[1] : Bell;
};
